import React from "react";
import ProfilesAndSettings from "views/Config/Profiles/Common";
import { composedAPI } from "./api";
import policyRateComposition from "./composition";
import help from "help/viewPolicyRateProfileConfig.md";
import settingsHelp from "help/viewPolicyRateProfileConfigSettings.md";

const ConfigPolicyRateProfiles = ({ ...settings }) => (
  <ProfilesAndSettings
    {...policyRateComposition}
    {...composedAPI}
    {...settings}
    help={help}
    settingsHelp={settingsHelp}
  />
);

export default ConfigPolicyRateProfiles;
